const sendProductRequest = (
  email: string,
  ecommerce: string,
  featureText: string,
  source: 'store' | 'product-request'
) => {
  const zapierUrl = 'https://hooks.zapier.com/hooks/catch/12823629/2hrszol/'
  const payload = {
    user: email,
    ecommerce: ecommerce,
    feature: featureText,
    source
  }
  return fetch(zapierUrl, {
    method: 'POST',
    body: JSON.stringify(payload)
  })
}

const sendReferral = (
  group: string,
  referrerEmail: string,
  referredEmail: string,
  referredPhone?: string,
  referredBrand?: string,
  referredWebsite?: string,
  language?: string
) => {
  const zapierUrl = 'https://hooks.zapier.com/hooks/catch/12823629/2hrszol/'

  const payload = {
    referredEmail: referredEmail,
    group: group,
    referrerEmail: referrerEmail,
    is_referral: true,
    referredPhone: referredPhone,
    referredBrand: referredBrand,
    referredWebsite: referredWebsite,
    language: language
  }

  return fetch(zapierUrl, {
    method: 'POST',
    body: JSON.stringify(payload)
  })
}

const sendIncidentReport = (
  group: string,
  ecommerce: string,
  user: string,
  processId: string,
  incidentType: 'rever' | 'logistics',
  issueTitle: string,
  translatedIssueTitle: string,
  incidentDescription: string,
  language?: string,
  invoiceUrl?: string,
  photoUrls?: string[]
) => {
  const zapierUrl = 'https://hooks.zapier.com/hooks/catch/12823629/2ra6byp/'

  const payload = {
    group: group,
    ecommerce: ecommerce,
    user: user,
    processId: processId,
    incidentType: incidentType,
    issueTitle: issueTitle,
    translatedIssueTitle: translatedIssueTitle,
    incidentDescription: incidentDescription,
    language: language,
    invoiceUrl: invoiceUrl,
    photoUrls: photoUrls
  }

  return fetch(zapierUrl, {
    method: 'POST',
    body: JSON.stringify(payload)
  })
}

export default { sendProductRequest, sendReferral, sendIncidentReport }
